import React, { useMemo } from 'react';
import { Line } from 'react-chartjs-2';
import { tickColor, gridColor, baseFont } from './chartConstants';

const ResolvedLineChart = ({ resolvedTicketsChart }) => {
    const chartData = useMemo(() => {
        if (!Array.isArray(resolvedTicketsChart) || resolvedTicketsChart.length === 0) return null;
        const labels = resolvedTicketsChart.map((d, i) => {
            if (i === 0 || i === resolvedTicketsChart.length - 1 || i % 5 === 0) {
                const dt = new Date(d.date);
                return dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
            }
            return '';
        });
        return {
            labels,
            datasets: [{
                label: 'Resolved Tickets',
                data:  resolvedTicketsChart.map(d => d.count),
                fill:  true,
                backgroundColor: 'rgba(34, 197, 94, 0.15)',
                borderColor:     'rgba(34, 197, 94, 1)',
                borderWidth:     2,
                pointRadius:     3,
                pointHoverRadius: 5,
                pointBackgroundColor: 'rgba(34, 197, 94, 1)',
                pointBorderWidth: 0,
                lineTension: 0.35,
            }],
        };
    }, [resolvedTicketsChart]);

    const options = useMemo(() => {
        if (!resolvedTicketsChart) return {};
        return {
            maintainAspectRatio: false,
            legend: { display: false },
            tooltips: {
                mode: 'index', intersect: false,
                backgroundColor: '#1F2937',
                titleFontFamily: baseFont, titleFontSize: 12, titleFontStyle: 'bold',
                bodyFontFamily: baseFont,  bodyFontSize: 12,
                xPadding: 10, yPadding: 10,
                callbacks: {
                    title: (items) => {
                        const idx = items[0]?.index;
                        if (idx !== undefined && resolvedTicketsChart[idx]) {
                            const dt = new Date(resolvedTicketsChart[idx].date);
                            return dt.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
                        }
                        return '';
                    },
                    label: (item) => ` ${item.yLabel} ticket${item.yLabel !== 1 ? 's' : ''} resolved`,
                },
            },
            scales: {
                xAxes: [{ gridLines: { display: false }, ticks: { fontColor: tickColor, fontFamily: baseFont, fontSize: 11, maxRotation: 0, autoSkip: false } }],
                yAxes: [{ gridLines: { color: gridColor }, ticks: { fontColor: tickColor, fontFamily: baseFont, fontSize: 11, beginAtZero: true, callback: (v) => Number.isInteger(v) ? v : null } }],
            },
        };
    }, [resolvedTicketsChart]);

    if (!chartData) return <div style={{ color: tickColor, padding: 20 }}>No resolved ticket data for the last 30 days</div>;
    return <div style={{ height: '100%', minHeight: 160 }}><Line data={chartData} options={options} /></div>;
};

export default ResolvedLineChart;
